import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { validateFolderName } from '../common/Utils';

const CreateFolderModal = ({ show, onHide, onSubmit, currentPath, loading }) => {
  const [folderName, setFolderName] = useState('');
  const [validationError, setValidationError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const validation = validateFolderName(folderName);
    if (!validation.isValid) {
      setValidationError(validation.error);
      return;
    }

    setValidationError('');
    onSubmit(folderName.trim());
  };

  const handleClose = () => {
    setFolderName('');
    setValidationError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create New Subfolder</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Current Path:</Form.Label>
            <Form.Control
              type="text"
              value={currentPath}
              readOnly
              className="mb-3"
              style={{ backgroundColor: '#f8f9fa' }}
            />
          </Form.Group>
          
          <Form.Group>
            <Form.Label>Folder Name:</Form.Label>
            <Form.Control
              type="text"
              value={folderName}
              onChange={(e) => {
                setFolderName(e.target.value);
                if (validationError) setValidationError('');
              }}
              placeholder="Enter folder name"
              autoFocus
              required
            />
            {validationError && (
              <Alert variant="danger" className="mt-2 mb-0 py-2">
                {validationError}
              </Alert>
            )}
            <Form.Text className="text-muted">
              Folder names cannot contain: &lt; &gt; : " / \ | ? * or control characters
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            type="submit" 
            disabled={loading || !folderName.trim()}
          >
            {loading ? 'Creating...' : 'Create Folder'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateFolderModal;
